import './editors.css'

/**
 * Column input that renders as a dropdown when upstream schema columns
 * are available, or falls back to a text input when no schema exists.
 *
 * Props:
 *   columns  - Array of { name, type } from upstream schema (optional)
 *   value    - Current column name
 *   onChange - (newValue) => void
 *   placeholder - Input placeholder text
 *   disabled - Boolean
 *   className - Additional CSS class (default: 'editor-input')
 */
function ColumnInput({ columns, value, onChange, placeholder = 'Column', disabled = false, className = '' }) {
  // Schema available — render dropdown
  if (columns && columns.length > 0) {
    return (
      <select
        className={`editor-column-select ${className}`}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        <option value="">-- {placeholder} --</option>
        {columns.map((col) => (
          <option key={col.name} value={col.name}>
            {col.name} ({col.type})
          </option>
        ))}
      </select>
    )
  }

  // No schema — fall back to text input
  return (
    <input
      className={`editor-input ${className}`}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
    />
  )
}

export default ColumnInput
